import React, {Component} from "react";
import {Link} from "react-router-dom";
import * as Utils from "../../../Utils";

class Gnb extends Component {
    state = {
        tabMenuList: []
    }

    constructor(props) {
        super(props);
        // cookie 에서 identity를 이용하여 menu 구성
        const beaconCookie = props.decodedCookie;
        if (beaconCookie.jti === 'I_STUDENT') {
            this.state.tabMenuList = [
                {id: 0, text: "homework", hoverText: "숙제", link: "/app/homework", checked: false},
                {id: 1, text: "calendar", hoverText: "달력", link: "/app/calendar", checked: false},
                {id: 2, text: "online", hoverText: "온라인 강의", link: "/app/online", checked: false},
                // {id: 3, text: "reading", hoverText: "reading-test", link: "/app/reading", checked: false},
                //{id: 2, text:"support", hoverText:"지원", link: "/app/calendar", checked: false}
            ];
        } else if (beaconCookie.jti === 'I_BEACON') {
            this.state.tabMenuList = [
                {id: 0, text: "main", hoverText: "main", link: "/app/teacher", checked: false},
                {id: 1, text: "management", hoverText: "management", link: "/app/management", checked: false},
                {id: 2, text: "system", hoverText: "system", link: "/app/system", checked: false}
            ];
        } else if (beaconCookie.jti === 'I_ATTENDANCE') {
            this.state.tabMenuList = [
                {id: 0, text: "main", hoverText: "main", link: "/app/attendance", checked: false},
                {id: 1, text: "attendance", hoverText: "attendance", link: "/app/management", checked: false}
            ];            
        } else {
            this.state.tabMenuList = [
                {id: 0, text: "main", hoverText: "main", link: "/app/teacher", checked: false},
                {id: 1, text: "management", hoverText: "management", link: "/app/management", checked: false},
            ];
        }
        const {tabMenuList} = this.state;
        const selected = tabMenuList[props.selectedIndex];
        const changeList = [...tabMenuList];
        changeList[props.selectedIndex] = {
            ...selected,
            checked: !selected.checked
        };
        this.state = {
            tabMenuList: changeList
        };
    }

    onClick = () => {
        Utils.setDate(new Date());
    };

    setTabMenu = () => {
        const {tabMenuList} = this.state;
        const list = tabMenuList.map(
            ({id, text, checked, link}) => (
                <li className={(checked) ? 'li active' : 'li'} key={id}>
                    <Link to={link}><span onClick={this.onClick}>{text}</span></Link>
                </li>
            )
        );
        return list;
    };

    render() {
        return (
            <div className="gnbWrapper">
                <div className="gnbInner">
                    <ul>
                        {this.setTabMenu()}
                    </ul>
                </div>
            </div>
        );
    }
}

Gnb.defaultProps = {
    selectedIndex: 0,
    decodedCookie: {}
};

export default Gnb;



// WEBPACK FOOTER //
// ./src/components/Containers/Header/Gnb/index.js